import { Link } from "react-router-dom";

const FootSub = () => {
  const LinkComponet = ({ to, text }) => {
    return (
      <Link to={to}>
        <p className="text-xs text-footSubColor font-bold mx-3">{text}</p>
      </Link>
    );
  };

  const Divider = () => <p className="text-xs text-footSubColor font-bold mx-3">|</p>;
  return (
    <div className="flex">
      <LinkComponet to="/about-us" text="About Us" />
      <Divider />
      <LinkComponet to="/terms" text="Terms & Conditions" />
      <Divider />
      <LinkComponet to="/privacy" text="Privacy Policy" />
      <Divider />
      <LinkComponet to="/faq" text="FAQ" />
      <Divider />
      <LinkComponet to="/contact-us" text="Contact Us" />

      {/* <Link to="/terms">
        {" "}
        <p className="text-xs text-footSubColor font-bold mr-5 ml-5">
          Terms & Conditions
        </p>
      </Link>
      <p className="text-xs text-footSubColor font-bold mr-5 ml-5">|</p>
      <Link to="/privacy">
        {" "}
        <p className="text-xs text-footSubColor font-bold mr-5 ml-5">
          Privacy Policy
        </p>
      </Link> */}
    </div>
  );
};
export default FootSub;
